<template>
  <div class="login-wrapper">
    <img :src="$config.get('basePathFiles') + 'static/img/splash.png'" :class="{'welcome-logo':!isLoggedIn, 'welcome-logo-logged-in':isLoggedIn}"/>
    <div v-if="loading">
      <loading class="loggin-loading" :text="loadingText"/>
    </div>
    <div v-if="!isLoggedIn && !loading">
      <span class="lets-start">Let's start</span><br>
      <div class="login" v-if="nativeLoginEnabled">
        <form class="login-form" v-on:submit.prevent="loginPlaintext()">
          <div class="tr">
            <div class="login-field">
                <input name="username" @keyup.enter="loginPlaintext()" v-model="username" type="text" placeholder="Username">
            </div>
          </div>
          <div class="tr">
            <div class="login-field">
              <input name="password" @keyup.enter="loginPlaintext()" v-model="password" type="password" placeholder="Password">
            </div>
          </div>
        </form>
        <div class="tr">
          <div class="recaptcha-protection-msg">
            This site is protected by reCAPTCHA and the Google
            <a href="https://policies.google.com/privacy">Privacy Policy</a> and
            <a href="https://policies.google.com/terms">Terms of Service</a> apply.
          </div>
        </div>
        <div class="tr">
          <div class="login-button">
            <div @click="loginPlaintext()" class="button is-primary no-select">
              Log In
            </div>
          </div>
        </div>
        <div v-if="error" class="error">{{error}}</div>
      </div>
      <div class="oauth">
        <div v-if="nativeLoginEnabled && authenticationMethods.length > 0" class="or-separator">
          <span class="or">or</span>
        </div>
        <div v-for="(auth, i) in authenticationMethods" :key="i" class="authentication-buttons">
          <div @click="authenticate(auth)" class="button oauth-button justify-content-start" :style="{background: auth.color}">
            <i :class="auth.icon"></i>
            <span v-if="auth.title === 'Custom'" class="log-in-with">Log in with {{auth.name}}</span>
            <span v-else class="log-in-with">Log in with {{auth.title}}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="lower-left">{{version}}</div>
  </div>
</template>
<script src="https://www.google.com/recaptcha/api.js?render=reCAPTCHA_site_key"></script>
<script>

import Vue from 'vue'
import utils from '@/utils/utils.js';
import userUtils from '@/utils/userUtils.js';
import VueAuthenticate from 'vue-authenticate';
import error from '@/utils/error.js';
import { VueReCaptcha } from 'vue-recaptcha-v3';
import version from "../../version.json";
import configUtils from "@/utils/configUtils";

const _ = require('lodash');

export default {
  name: 'Login',
  data() {
    return {
      authenticationMethods: [],
      clientId: "",
      username: "",
      password: "",
      error: "",
      isLoggedIn: false,
      loading: false,
      loadingText: 'Logging in. Please wait...',
      nativeLoginEnabled: false,
      version: version.version,
      googleClientID:"",
      microsoftClientID:"",
      facebookClientID: ""
    }
  },
  mounted() {
    var t = this;
    t.isLoggedIn = userUtils.isLoggedIn(this.$store);
    configUtils.getSettingsProperty(t, "captchaClient")
    .then(captchaClient => {
      if (captchaClient) {
        utils.log(t, "captchaClient:", captchaClient)
        Vue.use(VueReCaptcha, { siteKey: captchaClient })
      } else {
        t.loading = false;
        t.error = "Recaptcha client not set. Please contact your administrator. 1"
      }
    })
    .catch(error => {
      t.loading = false;
      t.error = "Recaptcha client not set. Please contact your administrator. 2"
      console.error(error);
    })
    
    t.authenticationMethods = _.filter(this.$store.state.deviceFeatures.auth, function(value, key) {
      if(key === "itsi") {
        t.nativeLoginEnabled = value.enabled;
        return false;
      } else if(value.enabled) {
        value.title = _.capitalize(key);
        value.icon = t.getAwesomeFontIcon(key);
        value.color = t.getButtonColor(key);
        return true;
      }

      return false;
    });

    var url = t.$config.get("ecApi") + "features/devices";      
    return axios
    .get(url)
    .then(response => {
      t.googleClientID = response.data.auth.google.clientID
      t.microsoftClientID = response.data.auth.microsoft.clientID
      t.facebookClientID = response.data.auth.facebook.clientID
    })
    .catch(e => {
      t.loading = false;
      t.error = "502 server not found";
    });

    utils.log(this, t.authenticationMethods)
  },
  methods: {
    authenticate: function (providerData) {
      var t = this;
      t.loading = true;
      var provider = providerData.title;

      if (provider === "Google") {
        t.loadingText = "Waiting for Google login..."
      } else if (provider === "Microsoft") {
        t.loadingText = "Waiting for Microsoft login..."
        provider = "live";
      } else if (provider === "Facebook") {
        t.loadingText = "Waiting for Facebook login..."
      } else if (provider === "Custom") {
        t.loadingText = "Waiting for " + providerData.name + " login..."
        provider = "oauth2"
      }

      Vue.use(VueAuthenticate, {
        baseUrl: t.$config.get('dns') + '/educator',
        providers: {
          google: {
            clientId: t.googleClientID,
            redirectUri: t.$config.get('dns') + t.$config.get('basePathFiles') + 'auth/google/callback', // Google
          },
          live: {
            clientId: t.microsoftClientID,
            redirectUri: t.$config.get('dns') + t.$config.get('basePathFiles') + 'auth/microsoft/callback', // Microsoft
            scope: ["User.Read"]
          },
          facebook: {
            clientId: t.facebookClientID,
            redirectUri: t.$config.get('dns') + t.$config.get('basePathFiles') + 'auth/facebook/callback' // Facebook
          },
          oauth2: {
            name: providerData.name,
            url: '/auth/' + providerData.name,
            clientId: providerData.clientID,
            redirectUri: t.$config.get('dns') + t.$config.get('basePathFiles') + 'auth/custom/callback', // Custom
            authorizationEndpoint: providerData.authorizationURL,
            defaultUrlParams: ['response_type', 'client_id', 'redirect_uri'],
            requiredUrlParams: ["scope"],
            optionalUrlParams: ["display"],
            scope: providerData.scope,
            oauthType: '2.0',
            display: "popup",
            popupOptions: {
              height: 633,
              width: 452
            },
            responseType: 'code'
          },
          ldap: {
            name: providerData.name,
            url: '/auth/' + providerData.name,
            clientId: providerData.clientID,
            redirectUri: t.$config.get('dns') + t.$config.get('basePathFiles') + 'auth/custom/callback', // Custom
            authorizationEndpoint: providerData.authorizationURL,
            responseType: 'code'
          }
        }
      });

      provider = provider.toString().toLowerCase();
      t.$auth.authenticate(provider).then(function (response) {
        var url = t.$config.get('dns') + '/educator/oauth/webreader';
        axios.post(url, {
          provider: provider,
          code: response.data.code,
          scope: t.$auth.options.providers[provider].scope,
          redirectUri: t.$auth.options.providers[provider].redirectUri
        }).then(response => {
          if (response.data.info !== "Email address not found in EC")
            t.handleLogin(response.data, response.data.cookies["unity.jwt"].value);
          else {
            t.loading = false;
            t.error = "Email address not found. Please try with another email.";
          }
        }).catch(e => {
          console.error(e);
          setTimeout(() => {
            t.loading = false;
            t.error = "Email address not found. Please try with another email.";
          }, 15000);
        })
      }).catch(function(error){
        t.loading = false;
        console.error(error);
      })
    },
    objectToQuerystring: function (obj) {
      return Object.keys(obj).reduce(function (str, key, i) {
        var delimiter, val;
        delimiter = (i === 0) ? '?' : '&';
        key = encodeURIComponent(key);
        val = encodeURIComponent(obj[key]);
        return [str, delimiter, key, '=', val].join('');
      }, '');
    },
    loginPlaintext() {
      var t = this;
      let config = {
        headers: {
          'X-Auth-Mechanism': 'no-basic'
        }
      }

      var url = t.$config.get('ecApi') + "login";
      axios.post(url, {
        username: t.username,
        password: t.password,
        noRedirect: 1,
        noHash: 0
      }, config).then(response => {
        t.error = "";
        t.loadingText = "Logging in. Please wait...";
        t.loading = true;
        if (response.data.user && response.data.user.username) {
          t.recaptcha(response.data, response.data.hash);
        }
      }).catch(e => {
        t.loading = false;
        t.error = error.logAndGetError(t, e);
      })
    },
    handleLogin(data, cookieToken) {
      var t = this;
      // only users in config are allowed to acces this app
      userUtils.isAllowedRole(t, data.user).then(result => {
        if (result) {
          data.user.cookieToken = cookieToken;
          // handle successful login
          userUtils.userAndTokenReceived(data, this, function() {
            if(t.$route.query.redirect) {
              window.location.replace(t.$config.get('basePath') + t.$route.query.redirect);
              
            } else {
              utils.goHome(t);
            }
          });
        } else {
          this.loading = false;
          this.error = "Access denied.";
        }
      });
      // 
    },
    getAwesomeFontIcon: function(authTitle) {
      switch (authTitle) {
        case "custom":
          return "fas fa-user";
        case "facebook": 
          return "fab fa-facebook";
        case "google":
          return "fab fa-google";
        case "itsi":
          return "fas fa-user";
        case "ldap":
          return "fas fa-user";
        case "microsoft":
          return "fab fa-microsoft";
        default:
          return "fas fa-user";
      }
    },
    getButtonColor: function(authTitle) {
      switch (authTitle) {
        case "custom":
          return "#000000";
        case "facebook":
          return "#3b5998";
        case "google":
          return "#DD4B39";
        case "itsi":
          return "#2f67b1";
        case "ldap":
          return "#000000";
        case "microsoft":
          return "#00a2ed";
        default:
          return "#FFFFFF";
      }
    },
    async recaptcha(data, cookieToken) {
      var t = this;
      try {
        await t.$recaptchaLoaded();
        const token = await t.$recaptcha('login');
        var url = t.$config.get('ecApi') + "web/captcha?token=" + token;
        axios.get(url).then(response => {
          if (response.data.success) {
            if (response.data.score < 0.4 && t.version !== "local") {
              userUtils.logout(t, a => {
                t.loading = false;
                t.error = "Google was unable to authenticate you, please try again.";
                return;
              });
            } else {
              t.handleLogin(data, cookieToken);
              return;
            }
          } else {
            t.loading = false;
            this.error = "Google was unable to authenticate you, please try again.";
            return;
          }
        }, { withCredentials: true }).catch(e => {
          this.loading = false;
          this.error = "reCaptcha failed. Please contact the administrator.";
          console.error(e);
          return;
        })
      } catch (error) {
        console.error(error)
        t.error = "Recaptcha client not set. Please contact your administrator. 3";
        t.loading = false;
      }
    }
  }
}

</script>

<style scoped lang="scss">
@import "src/css/vars.scss";
  .login-wrapper {
    .loggin-loading {
      position: relative;
      margin-top: 50px;
    }

    .welcome-logo {
      width: 100%; 
      max-width: 350px; 
      height: auto; 
    }

    .error {
      color: red;
      padding-top: 10px;
    }

    .welcome-logo-logged-in {
      max-width: 350px;
      padding-top: 50px;
    }

    .lets-start {
      color: $primary-color;
      font-size: 13pt;
      font-weight: bold;
      text-align: center;
    }

    .next-button {
      margin-top: 15px;
      background: $primary-color;
      color: white;
    }

    .login {
      display: table;
      width: 85%;
      margin: 10px auto 15px auto;
      // border: 1px solid black;
      .login-form {
        width: 100%;
        display: table-header-group;
        .tr {
          display: table-row;
          width: 100%;
          .login-label {
            display: table-cell;
            text-align: left;
            // border: 1px solid black;
          }
          .login-field {
            display: table-cell;
            padding-bottom: 10px;
            // border: 1px solid black;
          }
          .emptyTD {
            display: table-cell;
            // border: 1px solid black;
          }          
          .login-button {
            text-align: center;
            display: table-cell;
            // border: 1px solid black;
          }
        }
      }
      .tr {        
        .recaptcha-protection-msg {
          display: table-cell;
          padding-bottom: 10px;
        }
      }
    }

    .oauth {
      display: flex;
      flex-direction: column;
      justify-content: center;
      text-align: center;
      margin: 10px 30px 0 30px;

      .or-separator {
        margin-top: 5px;
        border-top: 1px solid $dark-font-color;
      }

      .or {
        color: $dark-font-color;
        background-color: $background-color;
        width: 30px;
        display: block;
        margin: -11px auto 10px;
      }

      .authentication-buttons {
        margin-bottom: 5px;
        .oauth-button {
          color: white;
          width: 215px;
          .log-in-with {
            padding-left: 5px;
          }
        }
      }
    }
  }

  .justify-content-start {
    justify-content: flex-start;
  }

  .lower-left {
    position: fixed;
    bottom: 5px;
    left: 5px;
    font-size: 8pt;
    color: $dark-font-color-lightest;
  }
  
</style>